// PrivateRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';

// PrivateRoute component to check if the user is authenticated
const PrivateRoute = ({ children }) => {
  const isAuthenticated = !!localStorage.getItem('authToken'); // Check if the token exists in localStorage

  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;
